module.exports = __webpack_public_path__ + "static/media/new-Admission.6c4be938.jpg";